import React, { useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';

import './Counter.scss';
import { usePrevious } from '../../utils/hooks';
import Currency from '../Currency';

const Counter = ({ value, className = '' }) => {
  const prevValue = usePrevious(value);
  const [useInitial, setUseInitial] = useState(true);
  
  const { countUp, update } = useCountUp({
    start: value,
    end: value,
    duration: 4,
    prefix:"$",
    decimals: 0,
    separator:",",
    useEasing: true
  });

  //const 
  useEffect(() => {
    if (!prevValue) {
      return;
    }
    if (value === prevValue) {
      return;
    }
    if (!useInitial) {
      update(value);
      return;
    } else {
      setUseInitial(false);
    }
    update(value);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className={`counter ${className}`}>
      {useInitial && <Currency value={value} />}
      {!useInitial && <div>{countUp}</div>}
    </div>
  );
};

export default Counter
